// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "es6-promise/auto";
import Vue from "vue";
import App from "./App";
import VueRouter from "vue-router";
import Meta from "vue-meta";
import Raven from "raven-js";
import RavenVue from "raven-js/plugins/vue";
import { routes } from "./routes";
import { store } from "./store/store";

import Toastr from "vue-toastr";
import VeeValidate from "vee-validate";
import VueBreadcrumbs from "vue2-breadcrumbs";
import VueAnalytics from "vue-analytics";
import axios from "axios";
require("vue-toastr/src/vue-toastr.less");
Vue.component("vue-toastr", Toastr);

const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

// Add a response interceptor
axios.interceptors.response.use(
  (response) => {
    if (
      response.headers["x-token"] &&
      response.config.url.indexOf("api/v1") > 0
    ) {
      localStorage.setItem("sts_token", response.headers["x-token"]);
    }
    return response;
  },
  (error) => {
    if (
      error.response.status === 401 ||
      error.response.data.error === "token_expired"
    ) {
      store.dispatch("logout");
      router.push("/");
    }
    return Promise.reject(error);
  },
);

VeeValidate.Validator.extend("american_odds", {
  getMessage: (field) =>
    `${field} must be a valid American odds format (e.g., +150 or -200)`,
  validate: (value) => /^[-+]?([1-9]\d{0,2}|1000)$/.test(value),
});

// middleware
Vue.use(VueRouter);
Vue.use(VeeValidate);
Vue.use(VueBreadcrumbs);
Vue.use(Meta, {
  keyName: "metaInfo",
});
Vue.use(VueAnalytics, {
  id: "UA-36581750-1",
  router,
});
Raven.config("https://65d2bc6e5d6449f48b8aa0894f816737@sentry.io/185847", {
  release: "1.0.0",
  ignoreErrors: [
    /Validation Failed/,
    /Detected close during init/,
    "xcomponent",
    "adsbygoogle",
    "null is not an object (evaluating 'a.postMessage')",
    "No response from window",
    /Window closed for postrobot_method before ack/,
    "show_ads",
    "pagead",
    "Can not render button in IE intranet mode",
    "Out of memory",
    "postrobot_message_ack postrobot_ready error",
    "googleads.g.doubleclick.net",
  ],
  ignoreUrls: [/localhost/, /googlesyndication\.com/],
})
  .addPlugin(RavenVue, Vue)
  .install();
// new Vue instance
// attach Vue to the element with app id
// include App component globally
/* eslint-disable no-new */
new Vue(Vue.util.extend({ router, store }, App)).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js